<template>
<div class="my-4">
  <b-container fluid>
    <b-row class="mb-4" v-if="!loading">
      <b-col>
        <b-card class="mb-3">
          <b-container fluid>
            <b-row>
              <b-col>
                <b-dropdown id="tags-dropdown" variant="outline-primary" :text="riclist.name" size="lg">
                  <b-dropdown-item v-for="item in riclists" :key="'riclists' + item.id">
                    <router-link :to="{ name: 'Riclist', params: { id: item.id}}" class="dropdown-item p-1">{{item.name}}</router-link>
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col>
                <router-link :to="{ name: 'Riclists' }">all RIC Lists</router-link>
              </b-col>
            </b-row>
            <b-row v-if="riclist.comments">
              <b-col>
                <b-container class="ml-2 mt-2"><markdown :content="riclist.comments" /></b-container>
              </b-col>
            </b-row>
            <b-row v-if="editTag.description">
              <b-col>
                <b-form-textarea rows="8" id="titleInput" v-model="tag.description" placeholder="Tag Description (markdown)" required class="mt-2 mb-2"></b-form-textarea>
                <b-button class="mr-2" variant="primary" size="sm" @click="saveEdit" >Save</b-button>
                <b-button variant="outline-primary" size="sm" v-on:click="cancelEdit">Cancel</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="!loading">
      <b-col>
        <b-card class="mb-3" v-for="item in news" :key="item.id" :id="item.id">
          <publication
            v-bind:propItem="item"
            v-bind:key="item.id"
            :tagsProp=tags
            v-bind:username="user.username"
            :permissionAddArticle="permissionAddArticle"
            :permissionAddRisk="permissionAddRisk"
            :permissionAddTag="permissionAddTag"
            :permissionArticlesWip="permissionArticlesWip"
            :permissionInsights="permissionInsights"
            :permissionReadTagsPanel="permissionReadTagsPanel"
            />
        </b-card>
        <div v-show="loadingNews" class="text-center mb-4" align-h="center">
          <div><i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i></div>
        </div>
        <div v-show="!loadingNews" class="text-center mb-4" align-h="center">
          <b-button variant="primary" size="sm" v-if="showLoadMore" v-on:click="load">Load more</b-button>
        </div>
      </b-col>
      <b-col>
        <b-card class="mb-3">
          <h3>Insights</h3>
          <div class="mb-3" v-for="item in articles" :key="'article-' + item.id">
            <b-link :to="{ name: 'Article', params: { id: item.id}}">{{item.title}}</b-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import ac from '@/libs/accesscontrol'
import moment from 'moment'
import Publication from '@/components/PublicationNew'
import Markdown from '@/components/Markdown.vue'

export default {
  components: {
    Markdown,
    Publication
  },
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: async function () {
    this.$stat.log({ page: 'riclist', action: 'open riclist', model: 'tag', model_id: this.$route.params.id })
    this.permissionAddArticle = ac.can(this.user.acgroups).createAny('article').granted
    this.permissionAddRisk = true
    this.permissionAddTag = ac.can(this.user.acgroups).createAny('newstag').granted
    this.permissionArticlesWip = ac.can(this.user.acgroups).createAny('articleWorkflowEdit').granted
    this.permissionReadAnalytics = ac.can(this.user.acgroups).readAny('analytics').granted
    this.permissionInsights = true
    this.permissionReadTagsPanel = ac.can(this.user.acgroups).readAny('tagspanel').granted
    this.permissionEditTags = ac.can(this.user.acgroups).updateAny('tag').granted
    if (this.$config.BUILD === 'external') {
      this.permissionAddRisk = false
      this.permissionAddTag = false
      this.permissionArticlesWip = false
      this.permissionDeletePublication = false
      this.permissionInsights = ac.can(this.user.acgroups).readAny('article').granted
      this.permissionReadAnalytics = false
      this.permissionReadTagsPanel = false
      this.permissionEditTags = false
    }
    this.date = moment()
    try {
      this.tags = await this.$Amplify.API.get('cosmos', '/tags')
      this.riclists = await this.$Amplify.API.get('cosmos', '/standard/riclist')
    } catch (e) {
      this.$logger.warn('error getting events for a day', e)
    }
    this.firstLoad()
  },
  data () {
    return {
      articles: [],
      loading: true,
      loadingArticles: true,
      loadingNews: true,
      quarter: '',
      gridLoaderColor: 'black',
      gridLoaderSize: '10px',
      item: {},
      news: [],
      editTag: {
        description: false
      },
      permissionAddArticle: false,
      permissionAddRisk: false,
      permissionAddTag: false,
      permissionArticlesWip: false,
      permissionReadAnalytics: false,
      permissionReadTagsPanel: false,
      permissionEditTags: false,
      riclists: [],
      riclist: {},
      showLoadMore: true,
      showLoadMoreArticles: true,
      tagold: null,
      tags: [],
      limit: 50,
      offset: 0,
      page: 0,
      limitArticles: 200,
      offsetArticles: 0,
      pageArticles: 0
    }
  },
  methods: {
    firstLoad: async function () {
      this.showLoadMore = true
      this.$logger.debug('load started')
      this.loadingNews = true
      this.page = 0
      this.year = moment(this.date).year()
      this.quarter = moment(this.date).quarter()
      this.riclist = this.riclists.find(x => parseInt(x.id) === parseInt(this.$route.params.id))
      document.title = "KPMG Regulatory Horizon: " + this.riclist.name
      try {
        this.news = await this.$Amplify.API.get('cosmos', `/news/riclist/${this.$route.params.id}/limit/${this.limit}/offset/0`)
        if (this.news.length < this.limit) {
          this.showLoadMore = false
        }
        this.articles = await this.$Amplify.API.get('cosmos', `/articles/riclist/${this.$route.params.id}/limit/${this.limitArticles}/offset/0/flat`)
        if (this.articles.length < this.limitArticles) {
          this.showLoadMoreArticles = false
        }
        this.loading = false
        this.loadingNews = false
        this.loadingArticles = false
      } catch (e) {
        this.$logger.warn('load loading error' + e)
      }
    },
    load: async function () {
      this.$stat.log({ page: 'tag', action: 'open tag', model: 'tag', model_id: this.$route.params.id })
      this.$logger.debug('load started')
      this.loadingNews = true
      this.year = moment(this.date).year()
      this.quarter = moment(this.date).quarter()
      this.tag = this.tags.find(tag => parseInt(tag.id) === parseInt(this.$route.params.id))
      document.title = "KPMG Regulatory Horizon: " + this.tag.name
      this.page = this.page + 1
      this.offset = this.page * this.limit
      try {
        let apiName = 'cosmos'
        let path = `/news/riclist/${this.$route.params.id}/limit/${this.limit}/offset/${this.offset}`
        this.$logger.debug(path)
        let response = await this.$Amplify.API.get(apiName, path)
        if (response.length < this.limit) {
          this.showLoadMore = false
        }
        this.$logger.debug('load response: ', response)
        let news = response
        // push into existing array
        for (let i = 0, len = news.length; i < len; i++) {
          this.news.push(news[i])
        }
        this.$logger.debug(this.news)
        this.loading = false
        this.loadingNews = false
      } catch (e) {
        this.$logger.warn('load loading error' + e)
      }
    }
  },
  watch: {
    $route: async function () {
      this.loading = true
      this.$stat.log({ page: 'riclist', action: 'open riclist', model: 'riclist', model_id: this.$route.params.id })
      await this.firstLoad()
    }
  }
}
</script>

<style>
</style>
